


export const TagsSection = () => (
  <div className="space-y-3">
    <h3 className="text-xs font-semibold uppercase text-muted-foreground">Tags</h3>
    <input type="text" className="w-full border bg-background rounded px-3 py-1.5 text-sm" placeholder="Add tags..." />
  </div>
);
